import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from 'primeng/tabview';
import { CustomerSearchBarModule } from '../../shared/components/customer-searchbar/customer-search-bar.module';
import { ToggleSwitchModule } from '../../shared/components/toggle-switch/toggle-switch.module';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MaterialModule } from '../../shared/material.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CreateNotificationComponent } from './create-notification.component';
import { MyNotificationsComponent } from './my-notifications.component';

@NgModule({
    declarations: [
        CreateNotificationComponent,
        MyNotificationsComponent
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        MultiSelectModule,
        ReactiveFormsModule,
        CalendarModule,
        CustomerSearchBarModule,
        MaterialModule,
        SharedPipesModule,
        TabViewModule,
        ToggleSwitchModule,
        ValidationResultsModule
    ],
    exports: [
        CreateNotificationComponent,
        MyNotificationsComponent
    ]
})
export class NotificationTabModule {
}
